import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "text-center"
};
const _hoisted_3 = {
  class: "p-2 text-sm text-center text-gray-800"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "w-3/12 px-2 mb-1 bg-green-100"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "w-8/12 px-2 mb-1"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "w-3/12 px-2 mb-1 bg-green-100"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "w-8/12 px-2 mb-1"
};
const _hoisted_12 = {
  class: ""
};
const _hoisted_13 = {
  class: "row-fluid py-2"
};
const _hoisted_14 = {
  class: "w-full"
};
const _hoisted_15 = {
  class: "block font-bold text-base"
};
const _hoisted_16 = {
  class: "px-2 py-4 flex justify-end"
};
import { reactive, computed } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useInvoiceEmailStore } from "./useInvoiceEmailStore.js";
export default {
  __name: 'UpdateSubject',
  props: {
    reminderMode: {
      type: Number,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const invoiceEmailStore = useInvoiceEmailStore();
    const props = __props;
    let state = reactive({
      newSubject: "",
      subjectOptions: [{
        id: " {invoice_number}",
        detail: "The QuickBooks Online Invoice Number"
      }, {
        id: " {client_name}",
        detail: "Client's Display Name in Leanlaw"
      }, {
        id: " {invoice_date}",
        detail: "Invoice date"
      }, {
        id: " {date_due}",
        detail: "Date when the invoice is due"
      }, {
        id: " {matter_name}",
        detail: "Matter name (will be blank on multi-matter invoices)"
      }],
      trustRequestOption: [{
        id: "{client_name}",
        detail: "Client's Display Name in Leanlaw"
      }, {
        id: "{client_first_name}",
        detail: "Client's first name in Leanlaw"
      }, {
        id: "{client_last_name}",
        detail: "Client's last name in Leanlaw"
      }, {
        id: "{trust_amount_due}",
        detail: "Amount due from the trust request"
      }, {
        id: "{responsible}",
        detail: "Name of the Responsible user in LeanLaw"
      }, {
        id: "{matter_name}",
        detail: "Matter name (will be blank for client billed customers)"
      }],
      updateNewSubject: computed(() => {
        const customerRemainderSubject = props.reminderMode === 1 ? invoiceEmailStore.customerReminderSubject : invoiceEmailStore.customSubject;
        const customTrustRequestSubject = props.reminderMode === 2 ? invoiceEmailStore.customTrustRequestSubject : invoiceEmailStore.customSubject;
        return props.reminderMode === 1 ? customerRemainderSubject : props.reminderMode === 2 ? customTrustRequestSubject : invoiceEmailStore.customSubject;
      })
    });
    state.newSubject = state.updateNewSubject;
    function save() {
      invoiceEmailStore.toggleUpdateSubjectModal(state.newSubject, props.reminderMode);
    }
    function close() {
      let subject = props.reminderMode === 1 ? invoiceEmailStore.customReminderSubject : invoiceEmailStore.customSubject;
      invoiceEmailStore.toggleUpdateSubjectModal(subject, props.reminderMode);
    }
    function updateCustomField(optionId) {
      props.alerts.success(`${optionId} successfully copied to clipboard.`);
      navigator.clipboard.writeText(optionId);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, " Update " + _toDisplayString(props.reminderMode == 1 ? "Reminder" : "" || props.reminderMode == 2 ? "Trust Request" : "") + " Subject ", 1)]), _createElementVNode("div", _hoisted_3, " This is the subject used when your firm emails a" + _toDisplayString(props.reminderMode == 1 ? " reminder" : props.reminderMode == 2 ? " trust request" : "n") + " invoice. ", 1), _createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("span", null, "Keyword Options (click to copy)", -1)), props.reminderMode != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).subjectOptions, option => {
        return _openBlock(), _createElementBlock("div", {
          class: "flex justify-between items-center",
          key: option.id
        }, [_createElementVNode("span", _hoisted_5, _toDisplayString(option.id), 1), _createElementVNode("span", {
          class: "no-print pl-6 px-2 mb-1 cursor-pointer w-1/12 bg-green-100",
          onClick: _withModifiers($event => updateCustomField(option.id), ["prevent"])
        }, [...(_cache[3] || (_cache[3] = [_createElementVNode("span", {
          class: "fa fa-copy icon no-print"
        }, null, -1)]))], 8, _hoisted_6), _createElementVNode("span", _hoisted_7, _toDisplayString(option.detail), 1)]);
      }), 128))])) : _createCommentVNode("", true), props.reminderMode == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).trustRequestOption, option => {
        return _openBlock(), _createElementBlock("div", {
          class: "flex justify-between items-center",
          key: option.id
        }, [_createElementVNode("span", _hoisted_9, _toDisplayString(option.id), 1), _createElementVNode("span", {
          class: "no-print pl-6 px-2 mb-1 cursor-pointer w-1/12 bg-green-100",
          onClick: _withModifiers($event => updateCustomField(option.id), ["prevent"])
        }, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
          class: "fa fa-copy icon no-print"
        }, null, -1)]))], 8, _hoisted_10), _createElementVNode("span", _hoisted_11, _toDisplayString(option.detail), 1)]);
      }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("label", _hoisted_15, _toDisplayString(props.reminderMode == 1 ? "Reminder " : "" || props.reminderMode == 2 ? "Trust Request " : "") + "Subject: ", 1), _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(state).newSubject = $event),
        class: "w-full h-10 px-3 border-gray-300 border rounded focus:outline-none focus:shadow-outline focus:ring focus:ring-[rgba(var(--v-theme-primary),0.3)]"
      }, null, 512), [[_vModelText, _unref(state).newSubject]])])])])]), _createElementVNode("div", _hoisted_16, [_createVNode(LlSecondaryButton, {
        class: "px-12 mr-4",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => close(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        color: "primary",
        class: "px-12",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => save(), ["prevent"]))
      }, {
        default: _withCtx(() => [_createTextVNode(" Update" + _toDisplayString(props.reminderMode == 1 ? " Reminder " : "" || props.reminderMode == 2 ? "Trust Request" : "") + " Subject ", 1)]),
        _: 1
      })])]);
    };
  }
};